module.exports = __webpack_public_path__ + "img/revive.f5c5cbdf.jpg";